<!-- <fgb-banner-change></fgb-banner-change> -->
<div class="banner" role="banner">
  <h1>{{ 'subscriptions.page.title' | translate }}</h1>
</div>

<fgb-subscriptions-list></fgb-subscriptions-list>
